// removed by extract-text-webpack-plugin
module.exports = {"resizer":"column-resizer__resizer___f4rzm"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/column-resizer.css
// module id = 812
// module chunks = 0